import React from 'react';

const FormstackEntityApplicationSkeleton = () => (
  <div className="fs-embed-skeleton" aria-hidden="true">
    <div className="fs-skeleton-row fs-skeleton-row--wide" />
    <div className="fs-skeleton-row fs-skeleton-row--medium" />
    <div className="fs-skeleton-row fs-skeleton-row--wide" />
    <div className="fs-skeleton-row fs-skeleton-row--short" />
    <div className="fs-skeleton-row fs-skeleton-row--wide" />
    <div className="fs-skeleton-row fs-skeleton-row--medium" />
    <div className="fs-skeleton-button" />
  </div>
);

export default FormstackEntityApplicationSkeleton;
